var React = require('react');

function PlusInline (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"points":"26.77,11.87 18.21,11.87 18.21,3.31 12.13,3.31 12.13,11.87 3.57,11.87 3.57,17.95 12.13,17.95\n\t12.13,26.51 18.21,26.51 18.21,17.95 26.77,17.95 "}));
}

PlusInline.defaultProps = {"version":"1.1","id":"Design","x":"0px","y":"0px","viewBox":"0 0 29.55 29.55","style":{"enableBackground":"new 0 0 29.55 29.55"},"xmlSpace":"preserve"};

module.exports = PlusInline;

PlusInline.default = PlusInline;
